import { EvtSectionHeader } from "components/header";
import JobCoordinatorsSection from "@/modules/timesheet/dashboard/components/jc-section";
import PendingTimesheetBanner from "components/timesheet/dashboard/banner";
import ProjectCoordinatorsSection from "@/modules/timesheet/dashboard/components/pc-section";
import React from "react";
import TimesheetDashboardStats from "components/timesheet/dashboard/logs-overview";
import TimesheetPerformanceStat from "components/timesheet/dashboard/performance";
import ReviewerSection from "@/modules/timesheet/dashboard/components/reviewer-section";

const TimesheetDashboard = () => {
  return (
    <div className="flex-1 container ">
      <PendingTimesheetBanner />
      <section>
        <EvtSectionHeader title="Logs Overview" />
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4 md:px-6 px-4 mt-4.5 ">
          <TimesheetDashboardStats />
        </div>
      </section>
      <section className="mt-3.5">
        <EvtSectionHeader title="Performance (This Month)" />
        <div className="flex-1 lg:flex gap-4 lg:gap-0 items-center lg:flex-row grid sm:grid-cols-2 grid-cols-1 md:px-6 px-4 mt-4.5 overflow-auto">
          <TimesheetPerformanceStat />
        </div>
      </section>
      <ReviewerSection />
      <JobCoordinatorsSection />
      <ProjectCoordinatorsSection />
    </div>
  );
};

export default TimesheetDashboard;
